import React, { Component } from 'react';
import ClipboardJS from 'clipboard';
import tippy from 'tippy.js';
import Cookies from 'universal-cookie';

import appConfig from '../../config/client';
import { requiredInputBoxes, optionalInputBoxes, popupContent, radioButtonsFree, radioButtonsPaid, radioButtonsDefault, presetsParameters } from '../../modules/constants';
import { isUrl } from '../../modules/helpers';
import { createShortUrl } from '../../services/apiRequests';

import InputBox from '../../components/InputBox/InputBox';
import Popup from '../../components/Popup/Popup';
import RadioButton from '../../components/RadioButton/RadioButton';
import SelectBox from '../../components/SelectBox/SelectBox';
import QRCodeBox from '../../components/QRCodeBox/QRCodeBox';

const cookies = new Cookies();

class StartPage extends Component {

  state = {
    post: [],
    showShortenUrl: false,
    shortenUrl: '',
    originalUrl: '',
    customUrlCode: '',
    baseUrl: appConfig.baseUrl,
    showLoading: true,
    formError: {
      status: false,
      text: ''
    },
    exShortUrl: appConfig.baseUrl,
    utmSource: '',
    utmSourceDescription: '',
    utmMedium: '',
    utmMediumDescription: '',
    utmCampaign: '',
    utmCampaignDescription: '',
    utmContent: '',
    utmContentDescription: '',
    utmTerm: '',
    utmTermDescription: '',
    popupOpened: false,
    nameOfOpenedPopup: null,
    finalUrl: '',
    protocolSuit: 'https://',
    formTouched: false,
  };

  componentDidMount() {
    this.setState({
      showLoading: false,
    })
  }

  handleUserInput = (e) => {
    let {name, value} = e.target;

    if (name === 'customUrlCode') {
      value = value.replace(/[^a-zA-Z0-9_-]/g, '');
    }

    if (name === 'originalUrl') {
      value = value.replace('http://', '');
      value = value.replace('https://', '');
    }

    this.setState({
      [name]: value.trim(),
    },
      () => {
        this.createFinalUrl();
        this.setState({
          formError: {
            status: false,
            text: '',
          },
          formTouched: true,
        })
      }
    )
  }

  handleUserSelect = (e) => {
    if (e) {
      let {name, value} = e
      this.setState({
        [name]: value,
      },
        () => {
          this.setState({
            formError: {
              status: false,
              text: '',
            },
            formTouched: true,
          })
        }
      )
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.setState({
      formError: {
        status: false,
        text: '',
      },
      formTouched: false,
    });

    if (this.state.finalUrl && isUrl(this.state.finalUrl)) {

      this.setState({
        showLoading: true,
        showShortenUrl: false,
      });

      let reqObj = {
        originalUrl: this.state.finalUrl,
        customUrlCode: this.state.customUrlCode,
        uid: cookies.get('_uid', {path: '/'}),
        /*shortBaseUrl: this.state.baseUrl,*/
      };

      createShortUrl(reqObj)
        .then((json) => {
          this.setState({
            showLoading: false,
            showShortenUrl: true,
            shortenUrl: json.data.shortUrl,
          });

          new ClipboardJS('.clipboard-btn');

          tippy('.clipboard-btn', {
            content: 'Copied!',
            trigger: 'click',
            animation: 'inertia',
            placement: 'bottom',
            arrow: true,
          });
        })
        .catch((error) => {
          this.setState({
            showLoading: false,
            formError: {
              status: true,
              text: error.response.data.data ? error.response.data.data.message : 'Server Error'
            },
          });
        });
    } else {
      this.setState({
        formError: {
          status: true,
          text: 'URL is incorrect',
        },
      });
    }
  }

  handleQuestionClick = (name) => {
    this.setState({
      popupOpened: true,
      nameOfOpenedPopup: name,
    });
  }

  handlePopupClose = () => {
    this.setState({
      popupOpened: false,
    });
  }

  handleRadioClick = (e) => {
    if (e.target.dataset['type'] === 'paid') {
      this.setState(presetsParameters[e.target.value],
        () => {
          this.createFinalUrl();
          this.setState({
            formError: {
              status: false,
              text: '',
            },
            formTouched: true,
          });
        }
      )
    }
    
    if (e.target.dataset['type'] === 'free') {
      this.setState(presetsParameters[e.target.value]);

      const splitUrl = this.state.originalUrl.replace(/\/\s*$/, '').split('/');
      let lastNameUrl = splitUrl.length > 1 ? splitUrl[splitUrl.length - 1] : '';
      lastNameUrl = lastNameUrl.replace( /\.[^/.]+$/, '' );
      lastNameUrl = lastNameUrl.replace(/[-!$%^&#*()_+|~=`{}:";'<>?,.]/g, '_').substr(0, 100);

      this.setState({
        utmCampaign: lastNameUrl
      },
        () => {
          this.createFinalUrl();
          this.setState({
            formError: {
              status: false,
              text: '',
            },
            formTouched: true,
          });
        }
      );
    }
  }

  handleChangeSelect = (e) => {
    this.setState({protocolSuit: e.target.value},
      () => {
        this.createFinalUrl();
      }
    );
  }

  renderButton = () => {
    if (!this.state.showLoading) {
      const classes = [
        'btn-large',
        'submit-btn',
        'waves-effect',
        'waves-light',
        'blue',
        'lighten-1',
        this.state.originalUrl ? '' : 'disabled',
        this.state.formTouched ? '' : 'disabled',
      ]
      return (
        <button
          className={classes.join(' ')}
          name="action"
          // onClick={this.handleSubmit}
        >
          Create short link
        </button>
      );
    } else {
      return (
        <div className="loader">
          <div className="preloader-wrapper small active">
            <div className="spinner-layer spinner-green-only">
              <div className="circle-clipper left">
                <div className="circle" />
              </div>
              <div className="gap-patch">
                <div className="circle" />
              </div>
              <div className="circle-clipper right">
                <div className="circle" />
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  createFinalUrl = () => {
    const protocol = this.state.protocolSuit;
    const url = this.state.originalUrl ? this.state.originalUrl : 'example.com';
    if (isUrl(`${protocol}${url}`)) {
      const urlObject = new URL(`${protocol}${url}`);
      const utmSource = this.state.utmSource ? this.state.utmSource : '';
      const utmMedium = this.state.utmMedium ? this.state.utmMedium : '';
      const utmCampaign = this.state.utmCampaign ? this.state.utmCampaign : '';
      const utmContent = this.state.utmContent ? this.state.utmContent : '';
      const utmTerm = this.state.utmTerm ? this.state.utmTerm : '';
  
      if (utmSource) {
        urlObject.searchParams.set('utm_source', utmSource);
      }
  
      if (utmMedium) {
        urlObject.searchParams.set('utm_medium', utmMedium);
      }
  
      if (utmCampaign) {
        urlObject.searchParams.set('utm_campaign', utmCampaign);
      }
  
      if (utmContent) {
        urlObject.searchParams.set('utm_content', utmContent);
      }
  
      if (utmTerm) {
        urlObject.searchParams.set('utm_term', utmTerm);
      }
  
      const finalUrl = urlObject.href.replace( /%7B/g, '{' ).replace( /%7D/g, '}' );
  
      this.setState({
        finalUrl,
      })
    }
  }

  render() {

    const {state} = this;
    const content = popupContent[state.nameOfOpenedPopup];

    const renderInputBox = (input, index) =>
    { switch(input.type) {
        case 'input':
          return <InputBox
                    key={input + index}
                    campaignTitle={input.campaignTitle}
                    label={input.label}
                    name={input.name}
                    placeholder={input.placeholder}
                    onChange={this.handleUserInput}
                    value={state[input.name]}
                    onQuestionClick={this.handleQuestionClick}
                    descriptionText={state[`${input.name}Description`]}
                  />
        case 'select':
          return <SelectBox
                  key={input + index}
                  campaignTitle={input.campaignTitle}
                  label={input.label}
                  name={input.name}
                  placeholder={input.placeholder}
                  onChange={this.handleUserInput}
                  value={state[input.name]}
                  onQuestionClick={this.handleQuestionClick}
                  descriptionText={state[`${input.name}Description`]}
                />
        default:
          break;
      }
    }

    return (
      <div className="landing">
        <form className="link-shortener-form" onSubmit={this.handleSubmit}>
          <div>
            <h3 className="subtitle">Paste your URL*</h3>
          </div>

          <div className="original-url-wrapper">
            <select
              className="original-url-protocol"
              value={state.protocolSuit}
              onChange={this.handleChangeSelect}
            >
              <option defaultValue value="https://">https://</option>
              <option value="http://">http://</option>
            </select>

            <input
              name="originalUrl"
              // type="url"
              placeholder="Paste your link..."
              value={state.originalUrl}
              onChange={this.handleUserInput}
              className='original-url'
            />
          </div>

          <div className="radio-buttons-container">
            <div>
              <h3 className="subtitle">Traffic source</h3>
            </div>

            <h4 className="radio-buttons-title">Default</h4>

            <div className="radio-buttons-wrapper">
              {
                radioButtonsDefault.map((radioButton, index) =>
                  <RadioButton
                    key={radioButton + index}
                    name='presets'
                    value={radioButton.value}
                    defaultChecked={radioButton.defaultChecked}
                    onChange={this.handleRadioClick}
                    spanText={radioButton.spanText}
                  />
                )
              }
            </div>

            <h4 className="radio-buttons-title">Free</h4>
            
            <div className="radio-buttons-wrapper">
              {
                radioButtonsFree.map((radioButton, index) =>
                  <RadioButton
                    key={radioButton + index}
                    name="presets"
                    value={radioButton.value+'Free'}
                    type="free"
                    defaultChecked={radioButton.defaultChecked}
                    onChange={this.handleRadioClick}
                    spanText={radioButton.spanText}
                  />
                )
                // some code
              }
            </div>

            <h4 className="radio-buttons-title">Paid</h4>

            <div className="radio-buttons-wrapper">
              {
                radioButtonsPaid.map((radioButton, index) =>
                  <RadioButton
                    key={radioButton + index}
                    name="presets"
                    value={radioButton.value+'Paid'}
                    type="paid"
                    defaultChecked={radioButton.defaultChecked}
                    onChange={this.handleRadioClick}
                    spanText={radioButton.spanText}
                  />
                )
              }
            </div>
          </div>

          <div className="parameters-container">
            <div className="parameters-column">
              <div>
                <h3 className="subtitle">Required parameters</h3>
              </div>
              {
                requiredInputBoxes.map((input, index) => renderInputBox(input, index))
              }
            </div>

            <div className="parameters-column">
              <div>
                <h3 className="subtitle">Optional parameters</h3>
              </div>

              {
                optionalInputBoxes.map((input, index) => renderInputBox(input, index))
              }
            </div>
          </div>

          <div>
            <h3 className="subtitle">Additional settings</h3>
          </div>

          <div className="parameter-input-box">
            <div className="parameter-top">
              <strong>Customize your link alias (optional)</strong>
            </div>

            <div className="parameter-bottom">
              <div className="input-box-description">
                <label className="input-box-label">
                  l.unigine.com/
                </label>

                <button
                  className="parameters-about-button waves-effect waves-light btn blue lighten-1"
                  type="button"
                  onClick={(e) => {this.handleQuestionClick(e.target.name)}}
                  name="customUrlCode"
                >?</button>
              </div>

              <input
                className="input-box-input"
                name="customUrlCode"
                placeholder="Enter your custom name..."
                value={state.customUrlCode}
                onChange={this.handleUserInput}
              />
            </div>
            
            <p className="input-box-text">Latin, digits, dash and underscore</p>
          </div>

          <div className="final-input-wrapper">
            <div>
              <h3 className="subtitle">Preview link before shorten</h3>
            </div>
            <input
              name="finalUrl"
              value={state.finalUrl}
              readOnly
              className="final-input"
            />
          </div>

          {this.renderButton()}

          {state.formError.status
            ? <div className="formError">{state.formError.text ? state.formError.text : 'URL is incorrect'}</div>
            : null
          }

        </form>

        {state.showShortenUrl
          ? (
              <div className="shorten-success">
                <div className="shorten-title">Shortened URL is:</div>

                <div className="shorten-link">
                  <a
                    target="_blank"
                    href={state.shortenUrl}
                  >{state.shortenUrl}</a>
                </div>

                <div className="shorten-clipboard-copy">
                  <a
                    data-clipboard-text={state.shortenUrl}
                    className="clipboard-btn waves-effect waves-light btn-large green lighten-1"
                  >Copy to clipboard</a>
                </div>
                
                <QRCodeBox shortenUrl={state.shortenUrl} />
              </div>
            )
          : (
            <div className="shorten-success-filler"/>
          )
        }

        {content ? <Popup
                open={state.popupOpened}
                closeOnDocumentClick={true}
                modal
                onClose={this.handlePopupClose}
            >
              <div className="modal-custom">
                <button className="close" onClick={this.handlePopupClose}/>
                <div className="header">{content.header}</div>
                <div className="content">{content.body}</div>
              </div>
            </Popup> : null
        }
      </div>
    );
  }
}

export default StartPage;



// WEBPACK FOOTER //
// ./src/containers/pages/StartPage.js